
import Vue from "vue";
import { IBreadCrumb } from "winfakt-vue-components";
export default Vue.extend({
	computed: {
		path():IBreadCrumb[] {
			return [
				{to: "/settings", value: this.$ct("general")},
				{value: this.$ct("extra-fields")}
			] as IBreadCrumb[];
		}
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
